import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Platform, PopoverController } from 'ionic-angular';
import { DatePicker } from '@ionic-native/date-picker';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { EventsProvider } from '../../providers/events/events';
import { LocationsProvider } from '../../providers/locations/locations';
import moment from 'moment';
import fetch from 'node-fetch';
import { AppState } from '../../config/state';
import { IMyDrpOptions } from 'mydaterangepicker';
// import { CoBrochureOptionsPopoverComponent } from '../../components/co-brochure-options-popover/co-brochure-options-popover';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { CoCalendarComponent } from '../../components/co-calendar/co-calendar';
/**
 * Generated class for the CoBrochurePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-brochure',
  templateUrl: 'co-brochure.html'
})

export class CoBrochurePage {
  private locations: Array<any> = [];
  private eventAges: Array<any> = [];
  private eventTypes: Array<any> = [];
  public endDate: string = '';
  public startDate: string = '';
  public email: string = '';
  private segmentTimeRange: any;
  private endDateDisplay: string = '';
  private startDateDisplay: string = '';
  selectedAges: Array<string> = [];
  selectedTypes: Array<string> = [];
  selectedLocations: Array<string> = [];
  viewType: string;
  menuSide: string;
  keyword: string;
  client: any;
  emailRegex: any;
  yesterdayDate = moment().subtract(1, 'day');
  sharedScreen: boolean = false;
  activeButtons: any = { fromTo: false, age: false, types: false, locations: false };
  // myDateRangePickerOptions: IMyDrpOptions = {
  //   // other options...
  //   dateFormat: 'mm/dd/yyyy',
  //   firstDayOfWeek: 'su',
  //   sunHighlight: false,
  //   markCurrentDay: true,
  //   selectorHeight: '450px',
  //   selectorWidth: '500px',
  //   height: '48px',
  //   width: '100%',
  //   selectionTxtFontSize: '18px',
  //   showClearBtn: false,
  //   showApplyBtn: false,
  //   openSelectorOnInputClick: true,
  //   editableDateRangeField: false,
  //   disableUntil: { year: this.yesterdayDate.year(), month: this.yesterdayDate.month() + 1, day: this.yesterdayDate.date() }
  // };
  constructor(public navCtrl: NavController, public navParams: NavParams, public httpClient: HttpClient, private location: LocationsProvider, private events: EventsProvider, private dp: DatePicker, private alert: AlertController, private platform: Platform, public state: AppState, public popoverCtrl: PopoverController, private toast : ToastAlertsProvider, private sounds : SoundsProvider) {
    this.viewType = this.state.mode;
    this.keyword = this.state.client.keyword;
    this.client = this.state.client;
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
    this.sharedScreen = this.state.sharedScreen;
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.state.patron) {
      this.email = this.state.patron.email;
    }
    let lintWindow: any = window; //lint was breaking shit
    if (lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(false);
    }
    window.addEventListener('native.keyboardhide', this.scrollWindow);
  }

  scrollWindow() {
    window.scroll(0, window.scrollY);
  }

  ngOnDestroy() {
    let lintWindow: any = window; //lint was breaking shit
    if (lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(true);
    }
    window.removeEventListener('native.keyboardhide', this.scrollWindow);
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  downloadBrochure(info) {
    let brochure = this.getFilters('pdf', info);
    if (brochure) {
      let self = this;
      let url = '';
      brochure['clientId'] = this.client.id;
      //brochure['clientId'] = 232;
      url = `http://${this.keyword}.libnet.info/brochure`;
      //this.httpClient.post(`http://${keyword}.libnet.info/brochure`, {brochuredata: JSON.stringify(brochure)})
      //  .subscribe(result => {
      //    return result;
      //  });

      //url = `http://seasons.dev.colin.libnet.info/brochure`;
      fetch(url, {
        method: 'post',
        body: JSON.stringify({ brochuredata: brochure })
      })
        .then(r => r.blob())
        .then(self.parseDownload)
      /*
      let fileTransfer: FileTransferObject = self.transfer.create();
      url = `http://${keyword}.libnet.info/brochure`;
      fileTransfer.download(url, 'EventBrochure.pdf').then((entry) => {
        console.log('dlmsg', "Successfully downloaded file!");
      }, (error) => {
        console.log('dlmsg', "Error: " + error);
      });
      */
    }
  }

  parseDownload(blob) {
    var pdfBlob = new Blob([blob], { type: 'application/pdf' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(pdfBlob);
      return;
    }

    const data = window.URL.createObjectURL(pdfBlob);
    var link = document.createElement('a');
    link.href = data;
    link.download = "EventBrochure.pdf";
    link.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(data);
    }, 100);

    //this.toast.showAlert("Success!", "Successfully sent email.", "success");
  }

  getFilters(type, info) {
    let brochureData = {
      format: type,
      end_date: moment(info.end).format("YYYY-MM-DD"),
      start_date: moment(info.start).format("YYYY-MM-DD"),
      email: info.email,
      ages: info.ages.length > 0? info.ages : ["all"],
      types: info.types.length > 0? info.types : ["all"],
      location: info.locations.length > 0? info.locations : ["all"],
      type: 1
    };
    return brochureData;
  }

  setBrochureParamsFromInput(filterObject, type) {
    this.email = filterObject.email;
    let filterInfo = {
      ages: filterObject.ages.length>0? filterObject.ages : ["all"],
      types: filterObject.eventType.length>0? filterObject.eventType : ["all"],
      start: moment(filterObject.dateRange.start).format("YYYY-MM-DD"),
      end: moment(filterObject.dateRange.end).format("YYYY-MM-DD"),
      // locations: this.branchList,
      selectedLocation: filterObject.locations.length>0? filterObject.locations : ["all"],
      email: filterObject.email
    }
    if (type === 'email') {
      this.sendBrochure(filterInfo);
    } else {
      this.downloadBrochure(filterInfo);
    }
  }

  sendBrochure(info) {
    if (this.emailRegex.test(info.email)) {
      let brochure = this.getFilters('email', info);
      if (brochure) {
        let self = this;
        brochure['clientId'] = this.client.id;
        //brochure['clientId'] = 157;

        //keyword = response.keyword;

        self.mailBrochure({ brochuredata: brochure }, this.keyword).then((data) => {
          //let resp = JSON.parse(data);
          if (data['sent']) {
          } else {
            this.toast.showAlert("", "Failed to send brochure to this email address.");
          }
        });
        this.toast.showAlert("", "Successfully sent brochure", "success");
      }
    } else {
      this.toast.triggerToast('Invalid email', '', 'warning', 3000);
    }
  }

  mailBrochure(params, clientKeyword) {
    /*
    fetch(`http://seasons.dev.colin.libnet.info/brochure`, {
        method: 'POST',
        body:  this.formEncode(params)
    })
    .then(res => {
      return res.json();
    });
     */
    let h = new HttpHeaders();
    h.append('Content-Type', 'application/json');
    var self = this;
    return new Promise(resolve => {
      this.httpClient.post(`https://${clientKeyword}.libnet.info/brochure_generator`, JSON.stringify(params))
        .subscribe(result => {
          self.toast.showAlert("", "Successfully sent email.", "success");
        });
    });
  }

  pickDateDesktop() {
    this.segmentTimeRange = null;
  }

  // segmentDateRange(event) {
  //   // console.log('event', event, this.segmentTimeRange);
  //   this.activeButtons.fromTo = false;
  //   switch (this.segmentTimeRange) {
  //     case ('thisWeek'):
  //       this.startDate = moment().startOf('week').format("YYYY-MM-DD");
  //       this.endDate = moment().endOf('week').format("YYYY-MM-DD");
  //       this.startDateDisplay = moment().startOf('week').format('MMMM Do, YYYY');
  //       this.endDateDisplay = moment().endOf('week').format('MMMM Do, YYYY');
  //       break;
  //     case ('nextWeek'):
  //       this.startDate = moment().add(1, 'week').startOf('week').format("YYYY-MM-DD");
  //       this.startDateDisplay = moment().add(1, 'week').startOf('week').format('MMMM Do, YYYY');
  //       this.endDate = moment().add(1, 'week').endOf('week').format("YYYY-MM-DD");
  //       this.endDateDisplay = moment().add(1, 'week').endOf('week').format('MMMM Do, YYYY');
  //       break;
  //     case ('thisMonth'):
  //       this.startDate = moment().startOf('month').format("YYYY-MM-DD");
  //       this.startDateDisplay = moment().startOf('month').format('MMMM Do, YYYY');
  //       this.endDate = moment().endOf('month').format("YYYY-MM-DD");
  //       this.endDateDisplay = moment().endOf('month').format('MMMM Do, YYYY');
  //       break;
  //     case ('nextMonth'):
  //       this.startDate = moment().add(1, 'month').startOf('month').format("YYYY-MM-DD");
  //       this.startDateDisplay = moment().add(1, 'month').startOf('month').format('MMMM Do, YYYY');
  //       this.endDate = moment().add(1, 'month').endOf('month').format("YYYY-MM-DD");
  //       this.endDateDisplay = moment().add(1, 'month').endOf('month').format('MMMM Do, YYYY');
  //       break;
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/pages/co-brochure/co-brochure.ts